import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"cost-estimator-footer__estimate-amount\">\n  {{yield}}\n</div>")